<!-- <div *ngIf="userToken==='admin'"> -->

<div *ngIf="loaded == 1" class="cw">

    <div class="mgt40">
        <h6 *ngIf="id === null" class="ft500">Agregar empresa</h6>
        <h6 *ngIf="id" class="mgt40 ft500">Editar empresa</h6>
        <hr>
    </div>

    <!-- FORMULARIO PARA AGREGAR / EDITAR DOCUMENTO DE LA COLECCIÓN -->
    <form>
        <div>
            <label>Nombre de la empresa</label>
            <input type="text" [(ngModel)]="empresa.nombre" [ngModelOptions]="{standalone: true}" class="fw">
        </div>
        <div>
            <label>Resumen</label>
            <input type="text" [(ngModel)]="empresa.resumen" [ngModelOptions]="{standalone: true}" class="fw">
        </div>
        <div>
            <label>Descripcion</label>
            <textarea class="fw" maxlength="5000" [(ngModel)]="empresa.descripcion"
                [ngModelOptions]="{standalone: true}">
                        </textarea>
        </div>
        <div>
            <label>Sitio Web</label>
            <input type="text" [(ngModel)]="empresa.sitioWeb" [ngModelOptions]="{standalone: true}" class="fw">
        </div>
        <div>
            <label>Enlace Linkedin</label>
            <input type="text" [(ngModel)]="empresa.enlaceLinkedin" [ngModelOptions]="{standalone: true}" class="fw">
        </div>
        <div>
            <label> Foto de Empresa </label>
            <input type="file" class="fw" id="file" (change)="cargarFoto($event, 'foto')" name="image"
                autocomplete="off" />
        </div>
        <div class="containerImg">
            <img *ngIf="empresa.foto" [src]="empresa.foto" alt="imagenEmpresa" class="fw fh">
        </div>
        <div>
            <label> Imagen de fondo </label>
            <input type="file" class="fw" id="file" (change)="cargarFoto($event, 'fotoFondo')" name="image"
                autocomplete="off" />
        </div>
        <div>
            <div class="imgFondoContainer">
                <img *ngIf="empresa.fotoFondo" [src]="empresa.fotoFondo" alt="fotoEmpresa" class="fw fh">
            </div>
        </div>
        <div class="mgt10">
            <label>¿Publicado?</label>
            <select [(ngModel)]="empresa.publicado" [ngModelOptions]="{standalone: true}" class="fw">
                <option [ngValue]="true">Publicado</option>
                <option [ngValue]="false">Borrador</option>
            </select>
        </div>
    </form>

    <div fxLayout="row" class="mgt10 mgb30">
        <button (click)="guardarEmpresa()" class="darkButton mgt10" >Guardar</button>
        <button *ngIf="id" (click)="onDelete()" class="mgl10 grayButton mgt10 red-5" >Eliminar</button>
    </div>

</div>


<div *ngIf="loaded == 0">
    <div *ssrExclude>
        <spinner></spinner>
    </div>
</div>


<!-- <div *ngIf="userToken==='visitante'">
    <permiso-insuficiente></permiso-insuficiente>
</div> -->